// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3r56_","additionalInfo":"AgreementModal_additionalInfo__14rVu"};